import _defineProperty from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty";
import that from "../that.js";
export default function disposable(value, dispose) {
  var _ref;

  var done = false;

  if (typeof dispose !== "function") {
    throw new Error("dispose is not a function");
  }

  return _ref = {}, _defineProperty(_ref, Symbol.iterator, that), _defineProperty(_ref, "next", function next() {
    return done ? {
      done: true
    } : (done = true, {
      done: false,
      value: value
    });
  }), _defineProperty(_ref, "return", function _return() {
    return done = true, dispose(value), {
      done: true
    };
  }), _defineProperty(_ref, "throw", function _throw() {
    return {
      done: done = true
    };
  }), _ref;
}